module.exports = __webpack_public_path__ + "img/VL_04_02.a52799db.png";